import React from 'react';
import styled from 'styled-components';
import { useProjectDetail } from 'lib/hooks/project/useProjectDetail';
import SyncMessage from 'components/project/SyncMessage';
import ExcuteApps from './ExcuteApps';
import { useProject } from 'lib/hooks/project/useProject';
import StageTimeline from './StageTimeline';

function ProjectTimeline() {
  const { projectCode, projectInfo, hasAlarm, hasOwnTimeline } = useProject();

  const { stage, timeline, ownerGroupCode, partnerStage, partnerTimeline } = projectInfo;

  const { handleEditProjectSync } = useProjectDetail();

  return (
    <StyledProject data-component-name="Project">
      <div className="project__info_top_item">
        {hasAlarm && (
          <div className="top_item syncMessage">
            <SyncMessage projectInfo={projectInfo} onEditProjectSync={handleEditProjectSync} />
          </div>
        )}

        <div className="top_item_box">
          <div className="timeline">
            <StageTimeline
              projectInfo={projectInfo}
              ownerGroupCode={ownerGroupCode}
              stage={stage}
              timeline={timeline}
              partnerStage={partnerStage}
              partnerTimeline={partnerTimeline}
              projectCode={projectCode}
            />
          </div>
          <div className="excuteApp">
            <ExcuteApps />
          </div>
        </div>
      </div>
    </StyledProject>
  );
}

const StyledProject = styled.div`
  position: relative;
  .project__info_top_item {
    position: relative;
    margin-bottom: 20px;
    .top_item_box {
      display: flex;
      justify-content: space-between;
      height: 80px;
      width: 100%;
      .timeline {
        width: 834px;
        background-color: #fff;
        border: 1px solid #e1e1e7;
        border-radius: 10px;
        height: 80px;
      }
      .excuteApp {
        width: calc(100% - 834px);
        height: 80px;
      }
    }
  }
`;

export default ProjectTimeline;
